// SHOW/HIDE OFF CANVAS
document.querySelectorAll('.off-canvas a').forEach((el) => {
  el.setAttribute('tabindex', '-1');
});

document.querySelectorAll('.open-off-canvas').forEach((openOffCanvas) => {
  openOffCanvas.addEventListener('click', (e) => {
    e.preventDefault();
    document.body.classList.add('off-canvas-open');
    document.querySelectorAll('.off-canvas').forEach((offCanvas) => {
      offCanvas.classList.add('show-off-canvas');
      offCanvas.querySelectorAll('a').forEach((offCanvasLink) => {
        offCanvasLink.removeAttribute('tabindex');
      });
    });
  });
});

document.querySelectorAll('.overlay, .close-off-canvas').forEach((overlay) => {
  overlay.addEventListener('click', (e) => {
    e.preventDefault();

    document.body.classList.remove('off-canvas-open');
    document.querySelectorAll('.off-canvas').forEach((offCanvas) => {
      offCanvas.classList.remove('show-off-canvas');

      offCanvas.querySelectorAll('a').forEach((offCanvasLink) => {
        offCanvasLink.setAttribute('tabindex', ' -1');
      });

      if (offCanvas.classList.contains('has-level-2')) {
        setTimeout(() => {
          offCanvas.classList.add('show-level-2');
        }, 350);
      }
    });
  });
});

document.querySelectorAll('.overlay').forEach((overlay) => {
  overlay.addEventListener('click', (e) => {
    e.preventDefault();

    document.querySelector('#nav-bar').style.zIndex = 999;
    document.body.classList.remove('mega-menu-open');
    document.querySelectorAll('#main-nav > ul > li.has-submenu').forEach((listItem) => {
      listItem.classList.remove('open');
    });
  });
});

document.querySelectorAll('#main-nav > ul > li.has-submenu').forEach((listItem) => {
  listItem.classList.remove('open');
});

// OFF CANVAS CHILDREN TOGGLE
document.querySelectorAll('.off-canvas ul li > a > .toggle-children').forEach((toggle) => {
  toggle.addEventListener('click', (e) => {
    e.preventDefault();

    toggle.parentNode.parentNode.classList.toggle('open');
  });
});

// OFF CANVAS BACK
document.querySelectorAll('.off-canvas-back > a').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    link.closest('.open').classList.remove('open');
  });
});
